/*
  Exclusive accordions — only one <details> in a named group stays open.

  Modern browsers do this natively via the `name` attribute on <details>.
  This is the fallback for browsers that do not, so the behaviour is the
  same everywhere. Detection is a feature test, not a UA sniff.
*/

(function () {
  var supportsExclusive = 'name' in HTMLDetailsElement.prototype;
  if (supportsExclusive) return;

  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;

      var group = details.getAttribute('name');
      if (!group) return;

      document.querySelectorAll('details[name="' + CSS.escape(group) + '"]').forEach(function (other) {
        if (other !== details) other.open = false;
      });
    },
    true // toggle does not bubble; capture catches it on the way down
  );
})();
